import { addMedia } from "../utils/media-utils";
import { findAncestorWithComponent } from "../utils/scene-graph";
import { ObjectContentOrigins } from "../object-types";

AFRAME.registerComponent("external-glb-importer", {
  init() {
    this.hasEnteredBefore = this.el.sceneEl.is("entered");
  },
  tick() {
    if (!this.hasEnteredBefore && this.el.sceneEl.is("entered")) {
      this.hasEnteredBefore = true;
      setTimeout(() => {
        this.loadExternalGLB();
      }, 500);
    }
  },
  loadExternalGLB() {
    const getGLBFromQueryParams = () => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("myMediaModel");
    };

    const glbUrl = getGLBFromQueryParams();
    if (!glbUrl) return;

    this.spawnMediaInFrontOfPlayerAndReturn(glbUrl);
  },
  spawnMediaInFrontOfPlayerAndReturn(src, mediaOptions = {}) {
    const contentOrigin = ObjectContentOrigins.URL;

    const offset = { x: 0, y: 0, z: -1.5 };
    const { entity, orientation } = addMedia(
      src,
      "#interactable-media",
      contentOrigin,
      typeof src === "object" && src !== null && "name" in src && src.name === "message.png" ? "message" : null,
      !(src instanceof MediaStream),
      true,
      true,
      mediaOptions
    );
    orientation.then(or => {
      entity.setAttribute("offset-relative-to", {
        target: "#avatar-pov-node",
        offset,
        orientation: or
      });
    });

    return entity;
  }
});
